var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stripe-checkout',{ref:"checkoutRef",attrs:{"mode":"subscription","pk":_vm.publishableKey,"line-items":_vm.lineItems,"success-url":_vm.successURL,"cancel-url":_vm.cancelURL},on:{"loading":v => _vm.loading = v}}),_c('button',{on:{"click":_vm.submit}},[_vm._v("Subscribe!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }